import { Component } from '@angular/core';
import {
  faFacebookF,
  faYoutube,
  faXTwitter,
  faFlickr,
} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  faFacebookF = faFacebookF;
  faX = faXTwitter;
  faYoutube = faYoutube;
  faFlickr = faFlickr;
}
